import * as types from "../../actions/ActionTypes";
import { objectInitial } from "../../store/InitialStore";
export default function LoginForm(state = objectInitial, action) {
  const { type, payload } = action;
  switch (type) {
    case types.LOGIN_LOADING:
      return { payload, loading: true, error: false };
    case types.LOGIN_SUCCESS:
      return { payload, loading: false, error: false };
    case types.LOGIN_ERROR:
      return { payload, loading: false, error: true };
    default:
      return state;
  }
}
